export default (date) => {
  let newDate = new Date(date);

  let dd = newDate.getDate();
  let mm = newDate.getMonth() + 1;
  let yyyy = newDate.getFullYear();
  let hh = newDate.getHours();
  let MM = newDate.getUTCMinutes();

  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  if (MM < 10) {
    MM = '0' + MM;
  }

  return `${dd}/${mm}/${yyyy} - ${hh}:${MM}`;
};
